// Copyright (c) 2022 by Move Closer

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const FavouriteProductsServiceType = Symbol.for('IFavouriteProductsService')

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export interface IFavouriteProductsService {
  /**
   * Checks whether product is in favourites
   */
  check (sku: string): Promise<boolean>
  /**
   * Adds product to favourite list
   */
  addToFavourite (sku: string): Promise<void>

  /**
   * Removes product from favourite list
   */
  removeFromFavourite (sku: string): Promise<void>
}
